import {
  Component,
  ContentChild,
  Input,
  TemplateRef,
  Signal,
  inject,
  OnInit,
  OnDestroy,
} from '@angular/core';
import {MatCardModule} from '@angular/material/card';
import {NgIf, NgTemplateOutlet} from '@angular/common';
import { EditOverlayComponent } from '../edit-overlay/edit-overlay.component';
import { RxAuthService } from 'src/app/services/rx-auth/rx-auth.service';
import { MediaQueryService } from '../../../../services/media-query/media-query.service';
import { map, Subscription } from 'rxjs';
import { toSignal } from '@angular/core/rxjs-interop';
import { SpecialRoutingService } from 'src/app/services/special-routing/special-routing.service';
import { SettingsService } from 'src/app/services/settings/settings.service'; // Import the SettingsService

@Component({
  selector: 'app-icon-card',
  templateUrl: './icon-card.component.html',
  styleUrls: ['./icon-card.component.scss'],
  imports: [MatCardModule, NgIf, NgTemplateOutlet, EditOverlayComponent],
  standalone: true,
})
export class IconCardComponent implements OnInit, OnDestroy {
  @ContentChild('iconLeftRef') iconLeftRef: TemplateRef<any> | undefined;
  @ContentChild('iconRightRef') iconRightRef: TemplateRef<any> | undefined;
  @ContentChild('subtextRef') subtextRef: TemplateRef<any> | undefined;

  private mediaService: MediaQueryService = inject(MediaQueryService);
  private settingsService: SettingsService = inject(SettingsService); // Inject the SettingsService
  private editModeSubscription!: Subscription; // Subscription to manage edit mode state

  public isMobile: Signal<boolean> = toSignal(
    this.mediaService.getDisplayType().pipe(map(({ isMobile }) => isMobile)),
    { initialValue: window.innerWidth < 768 }
  );

  public isEditMode: boolean = false; // Local property to track edit mode

  constructor(
    public auth: RxAuthService,
    public specialRoutingService: SpecialRoutingService
  ) {}

  @Input() title: string = '';
  @Input() text: string | null = '';
  @Input() inputData: any;

  titleBlockedList: String[] = [
    'total revenue',
    'gross profit share',
    'website visits',
    'web address',
  ];

  titleTickerList: String[] = [
    'corporation name',
    'corporation type',
    'stock symbol',
    'market cap',
  ];

  titleSectorList: String[] = ['sector'];

  titleHQList: String[] = ['headquarters'];

  ngOnInit(): void {
    // Subscribe to the edit mode state
    this.editModeSubscription = this.settingsService.editMode$.subscribe(
      (state) => {
        this.isEditMode = state;
      }
    );
  }

  ngOnDestroy(): void {
    // Unsubscribe to avoid memory leaks
    if (this.editModeSubscription) {
      this.editModeSubscription.unsubscribe();
    }
  }

  editMetrics(title: string) {
    // console.log('title', !this.titleBlockedList.includes(title.toLowerCase()));
    const baseUrl = '/research';
    const match = this.inputData.irn;
    const metaNameId = this.inputData.irn;
    const regionCode = 'ALL';
    const languageCode = 'ENG';
    const url = this.inputData.profileUrl;

    if (this.titleTickerList.includes(title.toLowerCase())) {
      const formId = 11;
      const matchType = 1;

      const queryParams = {
        form_id: String(formId),
        match_type: String(matchType),
        match: match,
        meta_name_id: metaNameId,
        region_code: regionCode,
        language_code: languageCode,
        url: url, // Encode the URL
      };

      const route = {
        path: baseUrl, // Only the base path
        queryParams: queryParams, // The query parameters as an object
      };
      this.specialRoutingService.redirectToMRAPath(route);
    } else if (this.titleSectorList.includes(title.toLowerCase())) {
      const formId = 54;
      const matchType = 1;

      const queryParams = {
        form_id: String(formId),
        match_type: String(matchType),
        match: match,
        meta_name_id: metaNameId,
        region_code: regionCode,
        language_code: languageCode,
        url: url, // Encode the URL
      };

      const route = {
        path: baseUrl, // Only the base path
        queryParams: queryParams, // The query parameters as an object
      };

      this.specialRoutingService.redirectToMRAPath(route);
    } else if (this.titleHQList.includes(title.toLowerCase())) {
      const formId = 18;
      const matchType = 1;

      const queryParams = {
        form_id: String(formId),
        match_type: String(matchType),
        match: match,
        meta_name_id: metaNameId,
        region_code: regionCode,
        language_code: languageCode,
        url: url, // Encode the URL
      };

      const route = {
        path: baseUrl, // Only the base path
        queryParams: queryParams, // The query parameters as an object
      };

      this.specialRoutingService.redirectToMRAPath(route);
    } else {
      console.log('Title not found');
    }
  }

  editIcon(iconTitle: string) {
    this.editMetrics(iconTitle); // Call the editProfile method with the appropriate ID
  }

  isValidUrl(string: string) {
    const urlPattern = new RegExp(
      '^(https?:\\/\\/)?' + // protocol
        '((([a-z0-9](?:[a-z0-9-]*[a-z0-9])?)\\.)+[a-z]{2,}|' + // domain name
        'localhost|' + // localhost
        '\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}|' + // IP address
        '\\[?[a-f0-9]*:[a-f0-9:%.~+\\-]*\\]?)' + // IPv6
        '(\\:\\d+)?(\\/[-a-z0-9+&@#/%=~_|\\?\\.:,]*)*$',
      'i'
    ); // path
    return !!urlPattern.test(string);
  }
}
